import { combineReducers } from "redux"

import { 
  channelReducer, 
  brandedContentReducer,
  searchResultsReducer,
  queryReducer,
  searchBarExpandedReducer,
  logoVisibleReducer,
  searchVisibleReducer,
  modalVisibleReducer,
} from "../reducers"

export const rootReducer = combineReducers({
  channelReducer,
  brandedContentReducer,
  searchResultsReducer,
  queryReducer,
  searchBarExpandedReducer,
  logoVisibleReducer,
  searchVisibleReducer,
  modalVisibleReducer,
})